import React from 'react';
import { useTranslation } from 'react-i18next';

import { useScreenClass, Row, Col } from 'components/Grid';
import Item from './components/Item';

import {
  Section,
  Container,
  Title,
  List,
} from './styles';

const BottomWave = () => {
  const { t } = useTranslation();
  const screenClass = useScreenClass();

  return (
    <Section>
      <Container screen={screenClass}>
        <Row gutterWidth={60}>
          <Col xs={12} sm={6}>
            <Title>{t('WAVE.BOTTOM_WAVE.TRAVELERS.TITLE')}</Title>
            <List>
              <Item text={t('WAVE.BOTTOM_WAVE.TRAVELERS.ITEMS.FIRST')} />
              <Item text={t('WAVE.BOTTOM_WAVE.TRAVELERS.ITEMS.SECOND')} />
              <Item text={t('WAVE.BOTTOM_WAVE.TRAVELERS.ITEMS.THIRD')} />
              <Item text={t('WAVE.BOTTOM_WAVE.TRAVELERS.ITEMS.FOURTH')} />
              <Item text={t('WAVE.BOTTOM_WAVE.TRAVELERS.ITEMS.FIFTH')} />
            </List>
          </Col>
          <Col xs={12} sm={6}>
            <Title>{t('WAVE.BOTTOM_WAVE.MANAGER.TITLE')}</Title>
            <List>
              <Item text={t('WAVE.BOTTOM_WAVE.MANAGER.ITEMS.FIRST')} />
              <Item text={t('WAVE.BOTTOM_WAVE.MANAGER.ITEMS.SECOND')} />
              <Item text={t('WAVE.BOTTOM_WAVE.MANAGER.ITEMS.THIRD')} />
              <Item text={t('WAVE.BOTTOM_WAVE.MANAGER.ITEMS.FOURTH')} />
              <Item text={t('WAVE.BOTTOM_WAVE.MANAGER.ITEMS.FIFTH')} />
            </List>
          </Col>
        </Row>
      </Container>
    </Section>
  );
};

export default BottomWave;
